var map = {
	".": 5,
	"./": 5,
	"./AddBooking": 15,
	"./AddBooking.js": 15,
	"./App": 3,
	"./App.css": 27,
	"./App.js": 3,
	"./App.test": 28,
	"./App.test.js": 28,
	"./Bookings": 6,
	"./Bookings.js": 6,
	"./CustomerProfile": 12,
	"./CustomerProfile.js": 12,
	"./Footer": 16,
	"./Footer.js": 16,
	"./FormInputField": 2,
	"./FormInputField.js": 2,
	"./Heading": 13,
	"./Heading.js": 13,
	"./Order": 4,
	"./Order.js": 4,
	"./Restaurant": 18,
	"./Restaurant.js": 18,
	"./RestaurantButton": 17,
	"./RestaurantButton.js": 17,
	"./Search": 7,
	"./Search.js": 7,
	"./SearchButton": 8,
	"./SearchButton.js": 8,
	"./SearchResults": 9,
	"./SearchResults.js": 9,
	"./TableBody": 11,
	"./TableBody.js": 11,
	"./TableHeading": 10,
	"./TableHeading.js": 10,
	"./TouristInfoCards": 14,
	"./TouristInfoCards.js": 14,
	"./data/fakeBookings": 29,
	"./data/fakeBookings.json": 29,
	"./images/error.gif": 22,
	"./images/glasgow-bridge.jpeg": 41,
	"./images/loading.gif": 21,
	"./images/london-christmas.jpeg": 42,
	"./images/manchester-riverside.jpeg": 43,
	"./index": 5,
	"./index.css": 26,
	"./index.js": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;